<template>
    <div @click="emitIt" class="js-learnworlds-overlay learnworlds-bg-default-overlay">

        <!--<slot name="overlay"></slot>-->
    </div>

</template>

<script>

    export default {
        data () {
            return {}
        },
        methods : {
            emitIt () {
                this.$emit('overlayClicked');
            },
            emitAt () {
                this.$emit('overlayClicked');
            }
        }
    }
</script>
